module.exports = __webpack_public_path__ + "img/L_319_0.4cd29bd6.png";